import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class SellersService {
  update(id, data) {
    return securedAxiosInstance.put(`/sellers/${id}`, toSnakeCase({ ...data }));
  }

  delete(id) {
    return securedAxiosInstance.delete(`/sellers/${id}`);
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/sellers", { params: toSnakeCase(params) });
  }

  getRanking(params) {
    return securedAxiosInstance.get("/sellers/ranking", { params: toSnakeCase(params) });
  }
}

export default new SellersService();
